"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = exports.JobType = void 0;
var JobType;
(function (JobType) {
    JobType["unlockDailyInsight"] = "unlockDailyInsight";
    JobType["updateListicleStories"] = "updateListicleStories";
    JobType["updateDataInsights"] = "updateDataInsights";
    JobType["updatePatternScores"] = "updatePatternScores";
    JobType["updateDailyPrompt"] = "updateDailyPrompt";
    JobType["testTask"] = "testTask";
    JobType["unlockQueuedStory"] = "unlockQueuedStory";
    JobType["updateAggregatePeerScores"] = "updateAggregatePeerScores";
    JobType["updateTraitEndorsements"] = "updateTraitEndorsements";
    JobType["updatePrimaryNature"] = "updatePrimaryNature";
    JobType["updateAllSnippets"] = "updateAllSnippets";
    JobType["updateMemberScores"] = "updateMemberScores";
    JobType["sendUpdatedScores"] = "sendUpdatedScores";
    JobType["sendNewFeatureAvailable"] = "sendNewFeatureAvailable";
    JobType["updatePatternScorePercentiles"] = "updatePatternScorePercentiles";
    JobType["createGenericModalFeedItem"] = "createGenericModalFeedItem";
    JobType["updateDimensionalScores"] = "updateDimensionalScores";
    JobType["migrateDeliveredDailyPrompts"] = "migrateDeliveredDailyPrompts";
    JobType["updateShareHash"] = "updateShareHash";
    JobType["computePersonalityAnalyses"] = "computePersonalityAnalyses";
    JobType["setIsIOS"] = "setIsIOS";
    JobType["createIntroducingPlusFeedItem"] = "createIntroducingPlusFeedItem";
    JobType["migrateRecommendeeUids"] = "migrateRecommendeeUids";
    JobType["createDailyPollFeedItem"] = "createDailyPollFeedItem";
    JobType["createPeerRatingFeedItem"] = "createPeerRatingFeedItem";
    JobType["deleteMemberTasksRecursive"] = "deleteMemberTasksRecursive";
    JobType["deleteOldFeedItems"] = "deleteOldFeedItems";
    JobType["migrateScoringModel"] = "migrateScoringModel";
    JobType["updateLoveReportData"] = "updateLoveReportData";
    JobType["updateProfileNutshell"] = "updateProfileNutshell";
    JobType["migrateMemberGender"] = "migrateMemberGender";
    JobType["createTrendingPostFeedItem"] = "createTrendingPostFeedItem";
    JobType["updateLoveArchetype"] = "updateLoveArchetype";
    JobType["enrollSelfUnderstandingPractice"] = "enrollSelfUnderstandingPractice";
    JobType["createSurveyLinkFeedItem"] = "createSurveyLinkFeedItem";
    JobType["createPremiumSurveyLinkFeedItem"] = "createPremiumSurveyLinkFeedItem";
})(JobType = exports.JobType || (exports.JobType = {}));
var JobStatus;
(function (JobStatus) {
    JobStatus["pending"] = "pending";
    JobStatus["started"] = "started";
    JobStatus["complete"] = "complete";
    JobStatus["failed"] = "failed";
    JobStatus["queued"] = "queued";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
